<p-card>
  <div class="mb-3"><strong>Container Infestation Rate</strong></div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #containerSelect
          appLockInitialWidth
          fluid="true"
          [options]="insectsContainersConcatenated"
          [(ngModel)]="containerItem.catalogContainerInsectGrowthStageId"
          data-testid="insectContainer"
          optionLabel="label"
          optionValue="value"
          filter="true"
          filterPlaceholder="Search Container"
          class="required"
          appendTo="body"
          (onChange)="onChangeContainer()"
          [disabled]="isDisabled || editingInstance"></p-select>
        <label for="on_label">Container</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex">
        <label for="active" style="padding-right: 1rem"
          >Standard :
          <i class="fa fa-circle-question" style="cursor: pointer; margin-left: 0.5rem" pTooltip="{{ standardTooltipText }}" tooltipPosition="right">
          </i>
        </label>
        <p-toggleswitch
          [(ngModel)]="containerItem.standard"
          data-testid="active"
          (onChange)="onStandardToggle($event)"
          [disabled]="containerItem.catalogContainerInsectGrowthStageId === null || isDisabled" />
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-inputnumber
          [(ngModel)]="containerItem.quantityPerContainer"
          class="required"
          inputId="quantity"
          [disabled]="containerItem.standard"
          [useGrouping]="false"
          data-testid="quantity"
          [style]="{ width: '100%' }"
          [min]="1"
          (ngModelChange)="onQuantityPerContainerChange($event)" />
        <label for="quantity">Insects per {{ selectedContainer?.containerTypeName || 'Container' }}</label>
      </p-floatlabel>
    </div>
  </div>

  <div class="grid">
    <div class="col">
      {{
        containerItem.quantityPerContainer !== null && containerItem.quantityPerContainer !== undefined && containerItem.quantityPerContainer !== 0
          ? containerItem.quantityPerContainer + ' per '
          : 'Standard Amount per '
      }}
      {{ selectedContainer?.containerTypeName || 'Container' }}
    </div>
  </div>
  <div class="grid">
    <div class="col">
      {{
        containerItem.numberOfContainers !== null && containerItem.numberOfContainers !== undefined && containerItem.numberOfContainers !== 0
          ? containerItem.numberOfContainers
          : 'TBD'
      }}
      {{ (selectedContainer?.containerTypeName || 'Container') + (containerItem.numberOfContainers !== 1 ? 's' : '') }}
    </div>
  </div>
</p-card>
